import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { InformationUrl } from '../../shared/urls/information.url';
import { WorldTravelNews } from '../../models/information/news.models';
import { Http} from '@angular/http';
import * as xml2js from 'xml2js';


@Injectable()
export class InformationService {

  constructor(
    private http: Http,
    public baseService : BaseService
  ) { }

  downloadFile(id){
    const url = InformationUrl.DOWNLOAD_FILE;
    return this.baseService.getById(url, id);
  }

  getMyTMBMemo() {
    const url = InformationUrl.GET_MYTMB_MEMO;
    return this.baseService.get(url);
  }


  getAllWorldTravelNew(callback) {
    //this.spinnerService.show();
    const url = InformationUrl.GET_WORLD_TRAVEL_NEW;
    this.http.get(url).subscribe(res => {
        //this.spinnerService.hide();
        if (res) {
            const data = res['_body'];
            xml2js.parseString(data, function (err, result) {
                const worldTravelNewsList = new Array<WorldTravelNews>();
                if (result) {
                    if (result.feed) {
                        if (result.feed.entry) {
                            if (result.feed.entry.length > 0) {
                                const entries = <Array<any>>result.feed.entry;
                                entries.forEach(element => {
                                    const tempObj = new WorldTravelNews();
                                    tempObj.id = (<string>element.NewsReportId[0]).trim();
                                    tempObj.memo = (<string>element.Details[0]).trim().replace(/\|e2\|\`9/g, '&');
                                    tempObj.publiser = (<string>element.NewsCategoryName[0]).trim() +
                                        ' ' + (<string>element.CountryName[0]).trim();
                                    tempObj.publishDate = new Date((<string>element.ReceivedDate[0]).trim());
                                    tempObj.title = (<string>element.Headline[0]).trim();
                                    worldTravelNewsList.push(tempObj);
                                });
                                callback(worldTravelNewsList);
                            }
                        }
                    }
                }
                callback(worldTravelNewsList);
            });
        }
    }, error => {
        //this.spinnerService.hide();
        callback(null);
    });
}
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/information/information.service.ts